export const sortArrayFromKey = <T extends Record<string, any>>(arr: T[], field: keyof T): T[] => {
  if (!arr?.[0]?.[field]) {
    return arr;
  }
  return arr.sort((el1, el2) => (el1[field] < el2[field] ? -1 : 1));
};
